import React from 'react';
import Modal from 'react-responsive-modal';
import _ from 'lodash';
import Translate from 'translate';

class TokenModalLEC extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal little
             modalClassName="col-md-6 client-folder p-0"
             open={open}
             onClose={onClose}>

        <div className="p-3 mb-4 bg-blue">
        <h5 className="m-0 d-inline-block"><Translate id="token"/> {_.get( data, 'Token' ) ? data.Token.match(/.{1,4}/g).join('.') : '-'}</h5>
        </div>

        <div className="row mb-3 px-3">
          <div className="col-md-5">
            <p className="mb-1"><b><Translate id="PurchaseDate"/>:</b> {_.get( data, 'Date', '-' )}</p>
            
          </div>
          <div className="col-md-3">
            <p className="mb-1"><b><Translate id="Amount"/>:</b> {_.get( data, 'Amount', '-' )}</p>
          </div>
          <div className="col-md-4">
            <p className="mb-1"><b><Translate id="Receipt"/>:</b> {_.get( data, 'DocNumber', '-' )}</p>
          </div>

        </div>
      </Modal>
    )
  }
}

module.exports = TokenModalLEC;



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/TokenModalLEC/index.js